import isObject from 'lodash/isObject';

const getCurrency = (price = {}) => {
  if (isObject(price) && 'currency' in price) {
    return price.currency;
  }

  // default
  return 'USD';
};

export default getCurrency;
